export default {
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)
}